/**
 * Utility function to combine route segments ensuring no double slashes.
 *
 * @param segments - An array of route segments.
 * @returns A single string combining the route segments with "/".
 */
export function combineRoutes(...segments: string[]): string {
  return segments.map(segment => segment.replace(/^\/|\/$/g, '')).join('/');
}
